import * as angular from "angular";
import {IHttpService, IQService} from "angular";
import {ApiConfig} from "../../commons/models/api-config.model";

export class OrganizationsRequestsService {

  base_url: string;

  constructor(private $http: IHttpService, private apiConfig: ApiConfig, private $q: IQService) {
    this.base_url = this.apiConfig.baseUrl + `/organizations`;
  }

  getOrganizations() {
    return this.$http.get(this.base_url)
      .then(res => {
        return this._sendResponseData(res)
      })
      .catch(error => {
        return this._sendError(error)
      });
  }

  getOrganization(organizationId) {
    return this.$http.get(this.base_url + '/' + organizationId)
      .then(res => {
        return this._sendResponseData(res)
      })
      .catch(error => {
        return this._sendError(error)
      });
  }

  deleteOrganization(organizationId) {
    return this.$http.delete(this.base_url + '/' + organizationId)
      .then(res => {
        return this._sendResponseData(res)
      })
      .catch(error => {
        return this._sendError(error)
      });
  }

  createOrganization(organization) {
    return this.$http.put(this.base_url, organization)
      .then(res => {
        return this._sendResponseData(res)
      })
      .catch(error => {
        return this._sendError(error)
      });
  }

  updateOrganization(organizationId, organization) {
    return this.$http.post(this.base_url + '/' + organizationId, organization)
      .then(res => {
        return this._sendResponseData(res)
      })
      .catch(error => {
        return this._sendError(error)
      });
  }

  getOrganizationSites(organizationId) {
    return this.$http.get(this.base_url + '/' + organizationId + '/sites')
      .then(res => {
        return this._sendResponseData(res)
      })
      .catch(error => {
        return this._sendError(error)
      });
  }

  getOrganizationPolicy(organizationId) {
    return this.$http.get(this.base_url + '/' + organizationId + '/policy')
      .then(res => {
        return this._sendResponseData(res)
      })
      .catch(error => {
        return this._sendError(error)
      });
  }

  getOrganizationRoles(organizationId) {
    return this.$http.get(this.base_url + '/' + organizationId + '/policy/roles')
      .then(res => {
        return this._sendResponseData(res)
      })
      .catch(error => {
        return this._sendError(error)
      });
  }

  getGlobals() {
    const url = this.apiConfig.baseUrl + `/globals`;
    return this.$http.get(url)
      .then(res => {
        return this._sendResponseData(res)
      })
      .catch(error => {
        return this._sendError(error)
      });
  }


  private _sendResponseData(response) {
    return this.$q.resolve(response.data);
  }

  private _sendError(response) {
    return this.$q.reject(response.data);
  }

}

angular
  .module('bringoz.admin.organizations')
  .service('organizationsRequestsService', OrganizationsRequestsService);
